import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Loader2, Check } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pwd.length < 8) {
      toast.error("Password must be at least 8 characters");
      return;
    }
    if (pwd !== confirm) {
      toast.error("Passwords do not match");
      return;
    }
    if (!token) {
      toast.error("Missing reset token");
      return;
    }
    setSubmitting(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pwd });
      setDone(true);
      toast.success("Password updated");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Reset failed");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#1A1A1A] text-[#F9F6F0] flex items-center justify-center px-6">
      <div className="w-full max-w-md" data-testid="reset-password-page">
        <p className="text-[10px] tracking-[0.3em] uppercase text-[#C5A880] mb-4">Webmaster</p>
        <h1 className="text-4xl lg:text-5xl font-light mb-10" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
          {done ? "Password updated" : "Set a new password"}
        </h1>

        {!done ? (
          <form onSubmit={submit} className="space-y-6">
            <div>
              <label className="text-[10px] tracking-[0.25em] uppercase text-[#A8A39A] mb-2 block">New password</label>
              <input type="password" required value={pwd} onChange={(e) => setPwd(e.target.value)} data-testid="reset-pwd" className="w-full bg-transparent border-b border-[#333] focus:border-[#C5A880] py-3 text-[#F9F6F0] outline-none" autoFocus minLength={8} />
              <p className="text-[10px] tracking-[0.2em] uppercase text-[#73706B] mt-2">Minimum 8 characters</p>
            </div>
            <div>
              <label className="text-[10px] tracking-[0.25em] uppercase text-[#A8A39A] mb-2 block">Confirm password</label>
              <input type="password" required value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-pwd-confirm" className="w-full bg-transparent border-b border-[#333] focus:border-[#C5A880] py-3 text-[#F9F6F0] outline-none" minLength={8} />
            </div>
            <button type="submit" disabled={submitting} data-testid="reset-submit" className="w-full bg-[#C5A880] text-[#1A1A1A] py-4 text-[11px] tracking-[0.25em] uppercase hover:bg-[#F9F6F0] disabled:opacity-60 transition-colors inline-flex items-center justify-center gap-2">
              {submitting && <Loader2 className="w-4 h-4 animate-spin" strokeWidth={1.5} />}
              {submitting ? "Updating" : "Update Password"}
            </button>
          </form>
        ) : (
          <div>
            <div className="inline-flex items-center justify-center w-14 h-14 border border-[#C5A880] mb-6">
              <Check className="w-6 h-6 text-[#C5A880]" strokeWidth={1.25} />
            </div>
            <p className="text-base text-[#A8A39A] mb-8 leading-relaxed">
              Your password has been updated. You can now sign in with the new password.
            </p>
            <button type="button" onClick={() => navigate("/admin/login")} data-testid="reset-go-login" className="w-full bg-[#C5A880] text-[#1A1A1A] py-4 text-[11px] tracking-[0.25em] uppercase hover:bg-[#F9F6F0] transition-colors">
              Go to sign in
            </button>
          </div>
        )}

        {!done && (
          <Link to="/admin/login" className="block text-center text-[10px] tracking-[0.25em] uppercase text-[#A8A39A] hover:text-[#C5A880] mt-6">
            Back to sign in
          </Link>
        )}
      </div>
    </div>
  );
}
